import Component from '../core/Component'
import EventBus from '../core/EventBus'
import Scroll from '../services/Scroll'

export const STATES = {
    LIGHT: 'is-light',
    ACTIVE: 'is-active',
    HIDDEN: 'is-hidden'

}
export default class Header extends Component {
    constructor(element) {
        super(element)

        this.isVisible = true
        this.isActive = false
        this.pageFooter = null
        this.footerDistance = 1000
    }

    prepare() {
        EventBus.on('footer:enter', this.handleFooterEnter)
        EventBus.on('footer:leave', this.handleFooterLeave)
        EventBus.on('swup:contentreplaced', this.handleSwupContentChanged)
        Scroll.on('scroll', this.handleScroll)
        this.setDark()
        this.pageFooter = document.querySelector(".Footer")
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll)
        EventBus.off('footer:enter', this.handleFooterEnter)
        EventBus.off('footer:leave', this.handleFooterLeave)
        EventBus.off('swup:contentreplaced', this.handleSwupContentChanged)
    }

    handleSwupContentChanged = () => {
        this.setDark()
        this.handleScroll(true)
    }

    handleScroll = (force = false) => {
        const offset = Scroll.getScroll()

        if (offset.y > 140) {
            if (!this.isActive || force) {
                this.isActive = true
                this.element.classList.add(STATES.ACTIVE)
            }
        } else {
            if (this.isActive || force) {
                this.isActive = false
                this.element.classList.remove(STATES.ACTIVE)
            }
        }

        if (this.pageFooter) {
            this.footerDistance = this.distanceFromFooter(this.pageFooter)

            if (this.footerDistance < 400) {

                this.hideHeader()
            } else {
                this.showHeader()

            }

        }
    }

    distanceFromFooter(element) {
        var rect = element.getBoundingClientRect()

        return rect.top
    }

    handleFooterEnter = () => {
        this.setLight()
    }

    handleFooterLeave = () => {
        this.setDark()
    }

    showHeader(){
        if(!this.isVisible){
            this.isVisible = true
            this.element.classList.remove(STATES.HIDDEN)
        }
    }

    hideHeader(){
        if(this.isVisible){
            this.isVisible = false
            this.element.classList.add(STATES.HIDDEN)
        }        
    }

    setDark() {
        this.element.classList.remove(STATES.LIGHT)
    }

    setLight() {
        this.element.classList.add(STATES.LIGHT)
    }
}
